import { IS_LOCAL_ENV } from "../App";
import { _axios } from "./config";
import qs from "qs";

export const createTutorial = async (props) => {
  try {
    const { data } = await _axios.post(`/api/tutorials`, { ...props });
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const getTutorials = async (page) => {
  try {
    const { data } = await _axios.get(`/api/tutorials${page ? `?page=${page}` : ""}`);
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const getTutorialsFiltered = async (page, queryObj) => {

  const stringifiedQuery = Object.keys(queryObj).length
    ? qs.stringify({ where: queryObj })
    : "";
  IS_LOCAL_ENV && console.log("query: ", stringifiedQuery);

  try {
    const { data } = await _axios.get(`/api/tutorials?page=${page}` +
      (stringifiedQuery ? `&${stringifiedQuery}` : "")
    );
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const updateTutorial = async (tutorialId, newStatus) => {
  try {
    const { data } = await _axios.patch(`/api/tutorials/${tutorialId}`, { status: newStatus });
    IS_LOCAL_ENV && console.log(data);
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const deleteTutorial = async (tutorialId) => {
  try {
    const { data } = await _axios.delete(`/api/tutorials/${tutorialId}`);
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}